import { render, staticRenderFns } from "./PoiLayer.vue?vue&type=template&id=38ad8f02&"
import script from "./PoiLayer.vue?vue&type=script&lang=js&"
export * from "./PoiLayer.vue?vue&type=script&lang=js&"
import style0 from "./PoiLayer.vue?vue&type=style&index=0&id=38ad8f02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports